const borderColor = "00000000";
export const borderStyleThin = {
  style: "thin",
  color: { argb: borderColor },
} as const;
